<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled" [placeholder]="'Dienstleister auswählen'">
  <nb-option *ngIf="showEmptyOption()" [value]="null">
    <span class="contractor-name">Alle</span>
  </nb-option>

  <nb-option *ngFor="let contractor of contractors()" [value]="contractor.id">
    <span class="contractor-name">{{ contractor.name }}</span>
  </nb-option>
</nb-select>
